import React from 'react'
import { MaybeLoaded } from 'json-react-layouts-data-loader'

import { Lima, LimaLayouts, RemainingLayouts } from 'component-library/collections-new/Lima/Lima'
import {
    ContentDataDefinitionLoader,
    CollectionDataLoaded,
    ContentDataTypes,
} from 'common/data/loader-definitions'
import {
    CollectionRouteProps,
    calculateExpectedCardCountFromContentData,
} from 'component-library/collections-new/collections-props.routing'
import { FontScales } from 'component-library/__styling/settings/fontScale'
import { LoadMore } from 'component-library/collections-new-loadmore/LoadMore/LoadMore'
import { LoadMoreProps } from 'component-library/collections-new-loadmore/LoadMore/LoadMore'
import { ImageWidths } from 'common/helpers/image'
import { CardOrientationOptions } from 'component-library/cards/Portrait/Portrait'
import { FixedRatio, CardBreakpointRatios } from 'common/client-data-types/image-item'
import {
    createRegisterableComponentWithData,
    ComponentServices,
} from 'common/routing/page-definition'
import { ThemeMargins } from 'component-library/__styling/settings/metrics'
import { TimestampType } from 'component-library/content/CardTimestamp/CardTimestamp'

export interface PerthNowProps extends Props {
    imageWidths?: ImageWidths['perthnow']
}
export interface TheWestProps extends Props {
    imageWidths?: ImageWidths['thewest']
}
export interface SevenNewsProps extends Props {
    imageWidths?: ImageWidths['sevennews']
}

interface Props extends CollectionRouteProps, LoadMoreProps {
    fixedRatios?: FixedRatio[] | CardBreakpointRatios
    hideTeaser?: boolean
    hideByline?: boolean
    hideKicker?: boolean
    timestamp?: TimestampType
    hideText?: boolean
    initialColumns?: number
    intermediateColumns?: number
    finalColumns?: number
    disableImageLazyLoad?: boolean
    hasBackground?: boolean
    fontScale?: FontScales
    textVerticalSpacing?: keyof ThemeMargins
    isSponsoredCollection?: boolean
    cardOrientation?: CardOrientationOptions
    cardLayout?: LimaLayouts
    remainingCardLayout?: RemainingLayouts
    stretchSelf?: boolean
    hasSeparator?: boolean
}

type InternalLimaRouteProps = Props & (PerthNowProps | TheWestProps | SevenNewsProps)

const renderLima = (
    props: InternalLimaRouteProps,
    data: MaybeLoaded<CollectionDataLoaded> & {
        dataDefinitionArgs: ContentDataTypes
    },
    services: ComponentServices
) => {
    return (
        <LoadMore
            dataDefinition={data.dataDefinitionArgs}
            services={services}
            loadMoreEnabled={props.loadMoreEnabled === true}
            data={data}
            render={loadMoreData => {
                return (
                    <Lima
                        items={
                            loadMoreData.loaded
                                ? { loaded: true, result: loadMoreData.result.publications }
                                : { loaded: false }
                        }
                        expectedCards={calculateExpectedCardCountFromContentData(
                            data.dataDefinitionArgs
                        )}
                        sectionHeader={props.sectionHeader}
                        hideByline={props.hideByline}
                        hideTeaser={props.hideTeaser}
                        hideKicker={props.hideKicker}
                        timestamp={props.timestamp}
                        hideText={props.hideText}
                        initialColumns={props.initialColumns}
                        intermediateColumns={props.intermediateColumns}
                        finalColumns={props.finalColumns}
                        textVerticalSpacing={props.textVerticalSpacing}
                        verticalSpacing={props.verticalSpacing}
                        fixedRatios={props.fixedRatios}
                        disableImageLazyLoad={props.disableImageLazyLoad}
                        hasBackground={props.hasBackground}
                        hasSeparator={props.hasSeparator}
                        fontScale={props.fontScale}
                        onEvent={services.onEvent}
                        isSponsoredCollection={props.isSponsoredCollection}
                        imageWidths={props.imageWidths}
                        cardOrientation={props.cardOrientation}
                        cardLayout={props.cardLayout}
                        remainingCardLayout={props.remainingCardLayout}
                        stretchSelf={props.stretchSelf}
                    />
                )
            }}
        />
    )
}

export const PerthNowLimaRegistration = createRegisterableComponentWithData(
    'lima',
    ContentDataDefinitionLoader,
    (props: PerthNowProps, data, services) =>
        renderLima({ ...props, imageWidths: props.imageWidths }, data, services)
)

export const TheWestLimaRegistration = createRegisterableComponentWithData(
    'lima',
    ContentDataDefinitionLoader,
    (props: TheWestProps, data, services) =>
        renderLima({ ...props, imageWidths: props.imageWidths }, data, services)
)

export const SevenNewsLimaRegistration = createRegisterableComponentWithData(
    'lima',
    ContentDataDefinitionLoader,
    (props: SevenNewsProps, data, services) =>
        renderLima({ ...props, imageWidths: props.imageWidths }, data, services)
)
